import type { BookingAnalyticsAudienceScope } from "@/queries/analytics/booking-reporting-types";

export function hasProjectConnectionAudience(scopes: BookingAnalyticsAudienceScope[]): boolean {
  return scopes.some((scope) => scope.type === "projectConnection");
}
